import { render, staticRenderFns } from "./ReviewUs.vue?vue&type=template&id=586ebeb8&scoped=true"
import script from "./ReviewUs.vue?vue&type=script&lang=js"
export * from "./ReviewUs.vue?vue&type=script&lang=js"
import style0 from "./ReviewUs.vue?vue&type=style&index=0&id=586ebeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586ebeb8",
  null
  
)

export default component.exports